var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wt-box',{class:_vm.classes,style:('width:' + _vm.size + ';height:'  + _vm.size + ';')},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }